/**
 * @desc 批量保存操作日志
 */
const URL = "/rantion-aider";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.aider.SaveOperationParamDto>, options?: any) {
  return updateResponse(
    http(URL + `/log/operation/batchSave`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
